import React, { useEffect, useState } from "react";
import Form_carriers_en from "./Form_carriers_en";
import Loader from "../Loader";
import Footer_en from "./Footer_en";
import Header_en from "./Header_en";
import Form_carriers_en_pfe from "./Form_carriers_en_pfe";
import Header_en_sav from "./Header_en_sav";

const Pfebook_en = () => {
  // State to control visibility
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Delay the visibility of the component
    const timer = setTimeout(() => {
      setIsVisible(true); // Set to visible after the delay
    }, 200);

    return () => clearTimeout(timer); // Clean up on unmount
  }, []);
  return (
    <div>
      <div>
        <Header_en_sav />
      </div>
      <Loader isVisible={isVisible} />
      <div>
        {/*=================================
page-title*/}

        {/*=================================
page-title */}
        {/*=================================
 careers*/}
        <section
          className="careers white-bg page-section-ptb"
          style={{ paddingTop: "170px" }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12">
                <div className="section-title text-center">
                  <h6></h6>
                  <h2 className="title-effect">PFE Project</h2>
                  <p className></p>
                </div>
              </div>
            </div>
            <div>
              <div>
                {/** */}
                <div className="accordion shadow">
                  {/**Model

                  <div className="acd-group acd-active">
                    <a className="acd-heading" href="#">
                      PFE-01: Application de dimensionnement d'un
                      transformateurAMIN
                    </a>
                    <div className="acd-des">
                      <div className="row">
                        <div className="col-lg-12 col-md-12">
                          <span>
                            <b>Department : </b>IT{" "}
                          </span>
                          <span>
                            <b>Objectif : </b>L'objectif principal du projet est
                            de développer une application capable de
                            dimensionner des transformateurs électriques tout en
                            optimisant les coûts associés. Cette application
                            vise à être un outil intuitif pour les ingénieurs,
                            facilitant la prise de décision technique.
                          </span>
                          <p className="mt-20" />
                        </div>
                      </div>
                      <br />
                      <div className="row">
                        <div className="col-lg-6 col-md-6">
                          <h4 className="mb-20 theme-color">
                            Les objectif de l’application{" "}
                          </h4>
                          <ul className="list list-unstyled mb-30">
                            <li>
                              <i className="fa fa-angle-right" /> Concevoir une
                              application capable de :
                            </li>
                            <li>
                              -Dimensionner un transformateur en fonction des
                              paramètres fournis (puissance, tension, fréquence,
                              etc.).
                            </li>
                            <li>
                              -Calculer les pertes et l'efficacité énergétique.
                            </li>
                            <li>
                              -Optimiser les coûts, incluant les coûts d'achat,
                              d'installation et d'exploitation.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Fournir une
                              interface utilisateur intuitive et ergonomique.{" "}
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Intégrer des
                              fonctionnalités de simulation pour comparer
                              différentes configurations
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Générer des
                              rapports automatisés.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Générer des
                              plans de fabrication des semis finis.
                            </li>
                          </ul>
                        </div>
                        <div className="col-lg-6 col-md-6">
                          <h4 className="mb-20 theme-color">
                            Partie fonctionnel
                          </h4>
                          <ul className="list list-unstyled mb-30">
                            <li>
                              <i className="fa fa-angle-right" /> Saisie des
                              paramètres techniques du transformateur
                              (puissance, tension primaire et secondaire, type
                              d'utilisation, etc.).
                            </li>
                            <li>
                              <i className="fa fa-angle-right" />{" "}
                              Dimensionnement automatique en fonction des normes
                              et des contraintes imposées.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Calcul des
                              coûts d’investissement et d’exploitation.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Comparaison de
                              plusieurs scénarios
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Propositions
                              d’alternatives optimales pour réduire les coûts.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Analyse des
                              pertes (fer, cuivre, charge partielle, etc.).
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-12">
                          <p className="mt-20 mb-20">
                            Les candidats intéressés sont invités à envoyer leur
                            CV à l'adresse e-mail suivante :
                          </p>
                          <a href="mailto:recrutement@sacemgroup.com">
                            recrutement@sacemgroup.com
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  */}
                  {/**1er pfe */}
                  <div className="acd-group acd-active">
                    <a className="acd-heading" href="#">
                      PFE-01: Smart platform
                    </a>
                    <div className="acd-des">
                      <div className="row">
                        <div className="col-lg-12 col-md-12">
                          <span>
                            <b>Department : </b>IT{" "}
                          </span>
                          <span>
                            <b>Objective : </b>The project aims to develop an
                            intelligent platform for monitoring, analysing and
                            predicting the prices of the main raw materials used
                            in the manufacture of electrical transformers.
                          </span>
                          <p className="mt-20" />
                        </div>
                      </div>
                      <br />
                      <div className="row">
                        <div className="col-lg-6 col-md-6">
                          <h4 className="mb-20 theme-color">
                            The objectives of the platforme
                          </h4>
                          <ul className="list list-unstyled mb-30">
                            <li>
                              <i className="fa fa-angle-right" /> Prediction of
                              the price of major commodities:
                            </li>
                            <li>• Copper.</li>
                            <li>• Magnetic sheet metal.</li>
                            <li>• Insulating mineral oil.</li>
                            <li>
                              <i className="fa fa-angle-right" /> Monitor price
                              changes in real time.{" "}
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> View price
                              trends (charts, indicators, historical data).
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Predict future
                              trends.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Recommend the
                              best time to buy.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Generate
                              automatic reports for the purchasing department
                              and management.
                            </li>
                          </ul>
                        </div>
                        {/** 
                        <div className="col-lg-6 col-md-6">
                          <h4 className="mb-20 theme-color">
                            Partie fonctionnel
                          </h4>
                          <ul className="list list-unstyled mb-30">
                            <li>
                              <i className="fa fa-angle-right" /> Saisie des
                              paramètres techniques du transformateur
                              (puissance, tension primaire et secondaire, type
                              d'utilisation, etc.).
                            </li>
                            <li>
                              <i className="fa fa-angle-right" />{" "}
                              Dimensionnement automatique en fonction des normes
                              et des contraintes imposées.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Calcul des
                              coûts d’investissement et d’exploitation.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Comparaison de
                              plusieurs scénarios
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Propositions
                              d’alternatives optimales pour réduire les coûts.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Analyse des
                              pertes (fer, cuivre, charge partielle, etc.).
                            </li>
                          </ul>
                        </div>
                        */}
                      </div>
                      <div className="row">
                        <div className="col-lg-12">
                          <p className="mt-20 mb-20">
                            Interested candidates are invited to submit their
                            application and CV using the form below.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/**2eme pfe */}
                  <div className="acd-group">
                    <a className="acd-heading" href="#">
                      PFE-02: PREDICTION OF TRANSFORMER DESIGNS
                    </a>
                    <div className="acd-des">
                      <div className="row">
                        <div className="col-lg-12 col-md-12">
                          <span>
                            <b>Department: </b> IT{" "}
                          </span>
                          <span>
                            <b>Objective: </b>The company wishes to implement an
                            intelligent system capable of predicting the optimal
                            designs for electrical transformers based on
                            technical specifications, production constraints and
                            historical data.
                          </span>
                          <p className="mt-20" />
                        </div>
                      </div>
                      <br />
                      <div className="row">
                        <div className="col-lg-6 col-md-6">
                          <h4 className="mb-20 theme-color">
                            The objectives of the application
                          </h4>
                          <ul className="list list-unstyled mb-30">
                            <li>
                              <i className="fa fa-angle-right" /> Reduce design
                              time.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Optimise
                              transformer costs and performance.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Leverage
                              historical data to anticipate needs and improve
                              quality.
                            </li>
                          </ul>
                        </div>
                        <div className="col-lg-6 col-md-6">
                          <h4 className="mb-20 theme-color">
                            Expected Features
                          </h4>
                          <ul className="list list-unstyled mb-30">
                            <li>
                              <i className="fa fa-angle-right" /> Prediction
                              module: propose an optimal design (dimensions,
                              materials, costs).
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Simulation:
                              evaluating the performance of proposed designs.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" />
                              Dashboard: tracking predictions, performance
                              indicators.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" />
                              Export: automatic generation of technical data
                              sheets.
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-12">
                          <p className="mt-20 mb-20">
                            Interested candidates are invited to submit their
                            application and CV using the form below.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/**3eme pfe */}
                  <div className="acd-group">
                    <a className="acd-heading" href="#">
                      PFE-03: INTELLIGENT SYSTEM FOR TRACKING TENDERS AND
                      BUSINESS OPPORTUNITIES
                    </a>
                    <div className="acd-des">
                      <div className="row">
                        <div className="col-lg-12 col-md-12">
                          <span>
                            <b>Department: </b> IT{" "}
                          </span>
                          <span>
                            <b>Objective: </b>
                            <br />
                          </span>
                          <p>
                            - Automatically monitor international tenders for
                            the sale of distribution transformers.
                          </p>
                          <p>
                            - Identify financing or funds available for
                            electricity projects around the world.
                          </p>
                          <p>
                            - Identify and report strategic business
                            opportunities for the company.
                          </p>
                          <p>
                            - Provide recommendations for the best time to
                            submit an offer or commence negotiations.
                          </p>
                          <p className="mt-20" />
                        </div>
                      </div>
                      <br />
                      <div className="row">
                        <div className="col-lg-6 col-md-6">
                          <h4 className="mb-20 theme-color">Key features</h4>
                          <ul className="list list-unstyled mb-30">
                            <li>
                              <i className="fa fa-angle-right" /> Data
                              collection
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Funding
                              monitoring
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Identifying
                              business opportunities
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Analysis and
                              prediction
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Alerts and
                              notifications
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> User interface
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Artificial
                              intelligence
                            </li>
                          </ul>
                        </div>
                        <div className="col-lg-6 col-md-6">
                          <h4 className="mb-20 theme-color">
                            Expected Features
                          </h4>
                          <ul className="list list-unstyled mb-30">
                            <li>
                              <i className="fa fa-angle-right" /> Save time and
                              improve responsiveness in international tenders.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Prioritise
                              funded and profitable opportunities.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" />
                              Identify and capitalise on strategic business
                              opportunities.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" />
                              Optimise your commercial strategy with AI-based
                              recommendations.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" />
                              Centralise all information on electricity projects
                              worldwide.
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-12">
                          <p className="mt-20 mb-20">
                            Interested candidates are invited to submit their
                            application and CV using the form below.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/**4eme pfe */}
                  <div className="acd-group">
                    <a className="acd-heading" href="">
                      PFE-04: IMPLEMENTATION OF AN SPC (STATISTICAL PROCESS
                      CONTROL) SYSTEM
                    </a>
                    <div className="acd-des">
                      <div className="row">
                        <div className="col-lg-12 col-md-12">
                          <span>
                            <b>Department: </b> Methodes{" "}
                          </span>
                          <span>
                            <b>Objective: </b>The project involves designing and
                            implementing a statistical process control (SPC)
                            system for a production process in order to optimise
                            it and improve its performance.
                          </span>
                          <p className="mt-20" />
                        </div>
                      </div>
                      <br />
                      <div className="row">
                        <div className="col-lg-6 col-md-6">
                          <h4 className="mb-20 theme-color">EProject stages</h4>
                          <ul className="list list-unstyled mb-30">
                            <li>
                              <i className="fa fa-angle-right" />
                              <b> Analysis of the manufacturing process:</b>
                              <p>• Detailed study of the production stages.</p>
                              <p>
                                • Identification of critical parameters
                                affecting the intrinsic characteristics and
                                quality of the product.
                              </p>
                            </li>
                            <li>
                              <i className="fa fa-angle-right" />
                              <b> Data collection and processing:</b>
                              <p>
                                • Systematic measurement of critical parameters
                                using precision instruments.
                              </p>
                              <p>
                                • Compilation of data for each batch in order to
                                establish a reliable statistical basis.
                              </p>
                            </li>
                            <li>
                              <i className="fa fa-angle-right" />
                              <b>SPC implementation:</b>
                              <p>
                                • Selection of appropriate statistical tools:
                                control charts (X-bar, R, P), histograms and
                                Pareto diagrams.
                              </p>
                              <p>
                                • Definition of control limits and alert
                                thresholds for each critical parameter.
                              </p>
                              <p>
                                • Continuous monitoring of batches to detect
                                abnormal variations and anticipate defects.
                              </p>
                            </li>
                            <li>
                              <i className="fa fa-angle-right" />
                              <b> Analysis and continuous improvement:</b>
                              <p>
                                • Identification of root causes of deviations
                                from control limits.
                              </p>
                              <p>
                                • Proposal for corrective measures to reduce
                                process variability.
                              </p>
                              <p>
                                • Optimisation of the manufacturing process to
                                improve overall quality and reduce scrap and
                                rework.
                              </p>
                            </li>
                          </ul>
                        </div>
                        <div className="col-lg-6 col-md-6">
                          <h4 className="mb-20 theme-color">
                            Expected results:
                          </h4>
                          <ul className="list list-unstyled mb-30">
                            <li>
                              <i className="fa fa-angle-right" /> Control charts
                              and operational tracking tables for production.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Reduction of
                              defects and scrap in the manufacture of magnetic
                              circuits.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" />
                              Complete documentation of the SPC process for
                              future application to other sections of the
                              factory.
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-12">
                          <p className="mt-20 mb-20">
                            Interested candidates are invited to submit their
                            application and CV using the form below.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/**5eme pfe */}
                  <div className="acd-group">
                    <a className="acd-heading" href="">
                      PFE-05: FMEA PROCESS STUDY
                    </a>
                    <div className="acd-des">
                      <div className="row">
                        <div className="col-lg-12 col-md-12">
                          <span>
                            <b>Department: </b> Methodes{" "}
                          </span>
                          <span>
                            <b>Objective: </b>The project consists of conducting
                            a FMEA production process study to identify, assess
                            and prioritise the risks of failure that could
                            affect the quality and reliability of finished
                            products.
                          </span>
                          <p className="mt-20" />
                        </div>
                      </div>
                      <br />
                      <div className="row">
                        <div className="col-lg-6 col-md-6">
                          <h4 className="mb-20 theme-color">
                            Project objectives:
                          </h4>
                          <ul className="list list-unstyled mb-30">
                            <li>
                              <i className="fa fa-angle-right" />
                              Identify and prioritise risks in the production
                              process.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" />
                              Reduce failures and improve the reliability of
                              manufactured products.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" />
                              Propose corrective actions to secure and optimise
                              the process.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" />
                              Contribute to the implementation of a proactive
                              quality approach in production.
                            </li>
                          </ul>
                        </div>
                        <div className="col-lg-6 col-md-6">
                          <h4 className="mb-20 theme-color">Project stages:</h4>
                          <ul className="list list-unstyled mb-30">
                            <li>
                              <i className="fa fa-angle-right" />
                              Analysis of the production process.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" />
                              Identification of failure modes.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" />
                              Criticality assessment.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" />
                              Proposals for corrective and preventive actions.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" />
                              Documentation and recommendations.
                            </li>
                          </ul>
                        </div>
                        <div className="col-lg-6 col-md-6">
                          <h4 className="mb-20 theme-color">
                            Expected results:
                          </h4>
                          <ul className="list list-unstyled mb-30">
                            <li>
                              <i className="fa fa-angle-right" /> Complete FMEA
                              table with failure modes, causes, effects, and
                              criticality indices.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" /> Action plan to
                              reduce priority risks.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" />
                              Improvement in process quality and reliability.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" />
                              Formal documentation that can be used as a
                              reference for internal audits or factory quality
                              certification.
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-12">
                          <p className="mt-20 mb-20">
                            Interested candidates are invited to submit their
                            application and CV using the form below.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/**6eme pfe */}
                  <div className="acd-group">
                    <a className="acd-heading" href="">
                      PFE-06: DESIGN AND MANUFACTURE OF A MACHINE FOR PRODUCING
                      WOODEN SLEEPERS
                    </a>
                    <div className="acd-des">
                      <div className="row">
                        <div className="col-lg-12 col-md-12">
                          <span>
                            <b>Department: </b> Methodes{" "}
                          </span>
                          <span>
                            <b>Objective: </b>The project consists of designing
                            and building an automated machine for the continuous
                            production of wooden parts with grooves, holes and
                            cut-outs. The equipment must be designed to
                            accommodate raw wood pieces with a maximum length of
                            6 m and to machine them completely in accordance
                            with the instructions of a CNC programme.
                          </span>
                          <br />
                          <h4 className="mb-20 theme-color">
                            <b>
                              The machine incorporates several functional
                              modules to ensure a continuous machining chain:
                            </b>
                          </h4>
                          <p className="mt-20" />
                        </div>
                      </div>
                      <br />
                      <div className="row">
                        <div className="col-lg-6 col-md-6">
                          <h4 className="mb-20 theme-color"></h4>
                          <ul className="list list-unstyled mb-30">
                            <li>
                              <i className="fa fa-angle-right" />A programmable
                              logic controller (PLC) providing centralised
                              control of operations, coordination of actuators,
                              and management of machining sequences according to
                              the parameters defined in the CNC programme.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" />A ø22 mm
                              drilling unit, designed for making fixing or
                              assembly holes, with precise positioning ensured
                              by the control system.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" />A mortising
                              machine, used to create grooves or mortises with
                              consistent precision along the length of the
                              workpiece.
                            </li>
                            <li>
                              <i className="fa fa-angle-right" />A final cutting
                              saw, designed to cut the workpiece once all
                              machining operations have been completed.
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-12">
                          <p className="mt-20 mb-20">
                            The system is designed to ensure smooth, repetitive
                            production that meets quality requirements, while
                            optimising machining times and reducing manual
                            intervention. This project draws on expertise in
                            industrial automation, mechanics, CNC programming
                            and systems integration to offer a comprehensive
                            solution for the continuous and reliable manufacture
                            of machined wooden parts.
                          </p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-12">
                          <p className="mt-20 mb-20">
                            Interested candidates are invited to submit their
                            application and CV using the form below.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/** */}
              </div>
              <div>
                <Form_carriers_en_pfe />
              </div>
            </div>
          </div>
        </section>
        {/*=================================
 careers*/}
      </div>
      <div>
        <Footer_en />
      </div>
    </div>
  );
};

export default Pfebook_en;
